import { DateTime } from 'luxon';
import { LevelTableCellProps } from 'redesign';
export enum paymentStates {
  BLOCKED = 'blocked',
  CREATED = 'created',
  READY_FOR_EARLY_PAYOUT = 'readyForEarlyPayout',
  READY_FOR_AUTOMATIC_PAYOUT = 'readyForAutomaticPayout',
  PAID_EARLY = 'paidEarly',
  PAID_AUTOMATICALLY = 'paidAutomatically',
}
export type getPaymentsData = {
  workerName: string;
  paymentId: string;
  creationDate: string;
  invoiceNumber: string;
  status: string;
  dueDate: string;
  invoiceUrl?: string | null;
};
export type PaymentsParsedData = {
  workerName: string;
  paymentId: string;
  creationDate: DateTime;
  status: string;
  dueDate: DateTime;
  invoice?: {
    invoiceUrl: string;
    invoiceReference: string;
  };
  actions: { paymentId: string };
};
export type PaymentsColumnDefinition = PaymentsParsedData;
export type PaymentsCellProp<T extends keyof PaymentsColumnDefinition> = LevelTableCellProps<
  PaymentsColumnDefinition,
  PaymentsColumnDefinition[T],
  PaymentsTableOptions
>;

export type PaymentsTableOptions = {
  getRowActions: (paymentId: string) => React.ReactNode[];
};
